const resources = {
    via: 'par',
    kebabAltText: 'Plus d’options'
};

export default function getResource(label) {
    return resources[label];
}
